module.exports = __webpack_public_path__ + "static/media/f4a085c3-1c64-4fc0-a598-26f3e658c2b0.3285c445.woff";